export const LOCATION_PLACEHOLDER_TEXT = 'Lookup location by name';
export const LOCATION_DATA_ID = 'customer_location_lookup';
export const CUSTOMER_LOOKUP_COMPANY_NAME_DATA_ID =
  'customer_company_lookup_company_name_field';
export const CUSTOMER_LOOKUP_ADDRESS_COUNTRY_FIELD = 'address.country';
export const CUSTOMER_LOOKUP_ADDRESS_STATE_FIELD = 'address.state';
export const CUSTOMER_LOOKUP_ADDRESS_REGION_FIELD = 'address.region';
export const CUSTOMER_LOOKUP_ADDRESS_CITY_FIELD = 'address.city';
export const CUSTOMER_LOOKUP_ADDRESS_POSTAL_CODE_FIELD = 'address.postalCode';
export const CUSTOMER_LOOKUP_ADDRESS_ADDRESS_LINE_1_FIELD =
  'address.addressLine1';
export const NOT_PROVIDED = 'Not provided';
export const CUSTOMER_LOOKUP_COMPANY_NAME_FIELD_NAME = 'companyName';
export const CUSTOMER_LOOKUP_LOCATION_FIELD_NAME = 'location';
export const MICROSOFT_CUSTOMER_SEARCH_ERROR_MESSAGE =
  'Microsoft’s customer search returned an error. Please search again. If the error continues, contact your admin.';

export const TYPOGRAPHY_STYLES = {
  fontFamily: "'Open Sans', sans-serif",
} as const;

export const TOAST_CONFIG = {
  position: 'top-right' as const,
  closeButton: true,
  autoClose: 4000,
  draggable: false,
};

export const FORM_STEP_CONTAINER_MIN_WIDTH = '420px';
export const FORM_STEP_CONTAINER_WIDTH = '100%';

export enum CustomerSearchFormStep {
  SEARCH = 'search',
  ACCOUNTS_LIST = 'accounts_list',
  LINKED_ACCOUNTS_LIST = 'linked_accounts_list',
}
